import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import LogoImg from './bicamsinlogo.jpg';
import NormalImg from '../common/Img';
import Button from '../common/Button';
import ParticipantDetails from './ParticipantDetails';
import { fetchParticipant } from '../../actions';

const Img = styled(NormalImg)`
  width: 300px;
  margin: 20px;
  display: block;
`;
const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;
const ButtonC = styled(Button)`
  background: #257CBD;
  color: #fff;
`;

class ParticipantDetailsPage extends React.Component {

  state = {
    redirect: false
  }

  componentDidMount = () => {
    const { match } = this.props;
    if (match.params.id) {
      this.props.fetchParticipant(match.params.id);
    }
  }

  render() {
    return (
      <div className="normalPage">
        <div className="container">
          <div className="row">
            <div className="col-xs-6">
              <Img src={LogoImg} alt="Bicams Logo" />
            </div>
            <div className="col-xs-6">
              <Link to={"/new_exam/"+this.props.match.params.id }><ButtonC className="btn btn-lg">Start New Exam</ButtonC></Link>
              <Link to="/participants"><ButtonA className="btn btn-lg">Go back</ButtonA></Link>
              <Link to="/logout"><ButtonB className="btn btn-lg">Logout</ButtonB></Link>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {
                this.state.redirect ?
                <Redirect to="/participants" /> :
                <ParticipantDetails
                  participant={this.props.participant}
                />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

}

function mapStateToProps(state, props) {
  const { match } = props;
  if (match.params.id) {
    return {
      participant: state.participants.find(item => item.Id === parseInt(match.params.id,10))
    }
  }

  return { participant: null };
}

export default connect(mapStateToProps, { fetchParticipant })(ParticipantDetailsPage);


// WEBPACK FOOTER //
// ./src/components/participants/ParticipantDetailsPage.js